import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { TextInputform, DropDown } from "../../components/Forms";
import { VscEye, VscEyeClosed } from "react-icons/vsc";
import { generateUserNoApi } from "../../services/UserService";

const UserCreation = ({ formData, setFormData, schema, editMode }) => {
  const [passwordVisibility, setPasswordVisibility] = useState({});

  const togglePasswordVisibility = (fieldName) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "name" && value.length >= 1) {
      try {
        if (editMode) {
          const currentUserNo = formData.user_no || "";
          const sequenceNumber = currentUserNo.slice(-3);
          let prefix = value.toLowerCase().slice(0, 4);
          prefix = prefix.replace(/[^a-z]/g, "");
          if (prefix.length < 4) {
            prefix = prefix.padEnd(4, "x");
          }
          const newUserNo = prefix.toUpperCase() + sequenceNumber;
          setFormData((prev) => ({ ...prev, user_no: newUserNo }));
        } else {
          const userNo = await generateUserNoApi(value);
          setFormData((prev) => ({ ...prev, user_no: userNo }));
        }
      } catch (error) {
        console.error("Error generating user_no:", error);
      }
    }
  };

  return (
    <div>
      <Container>
        <Row>
          {schema.map((field, index) => (
            <Col lg="12" md="12" xs="12" className="py-3" key={index}>
              {field.type === "dropdown" ? (
                <DropDown
                  placeholder={`Select ${field.label}`}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  options={field.options}
                />
              ) : (
                <TextInputform
                  textlabel={field.label}
                  PlaceHolder={field.label}
                  name={field.name}
                  value={formData[field.name] || ""}
                  formtype={
                    field.type === "password" && passwordVisibility[field.name]
                      ? "text"
                      : field.type
                  }
                  onChange={handleChange}
                  classname={field.classname || ""}
                  disabled={field.disabled || field.name === "user_no"}
                  suffix_icon={
                    field.type === "password" ? (
                      passwordVisibility[field.name] ? (
                        <VscEyeClosed
                          onClick={() => togglePasswordVisibility(field.name)}
                        />
                      ) : (
                        <VscEye
                          onClick={() => togglePasswordVisibility(field.name)}
                        />
                      )
                    ) : null
                  }
                />
              )}
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default UserCreation;
